// extracted by mini-css-extract-plugin
export var description = "CertificateModal-module--description--e7edd";
export var fadeInAnimation = "CertificateModal-module--fadeInAnimation--27fe4";
export var figcaption = "CertificateModal-module--figcaption--2b959";
export var figure = "CertificateModal-module--figure--329bd";
export var img = "CertificateModal-module--img--00c4a";
export var link = "CertificateModal-module--link--511f1";